import { action, computed, observable, makeObservable } from 'mobx';

export class DelayTimer {
  private readonly period: number;

  private interval: number;

  @observable
  private last: number | null;

  @observable
  private now: number;

  // period and updateInterval is in milliseconds
  constructor(period: number, updateInterval?: number) {
    makeObservable(this);
    this.period = period;
    this.last = null;
    this.now = Date.now();

    if (updateInterval === undefined)
      updateInterval = 500;
    this.interval = window.setInterval(this.updateNow, updateInterval);
  }

  @action
  private updateNow = () => {
    this.now = Date.now();
  };

  @computed
  get reached() {
    return this.last === null ||
      this.last + this.period < this.now;
  }

  @action
  reset = () => {
    this.now = Date.now();
    this.last = this.now;
  };

  dispose() {
    window.clearInterval(this.interval);
  }

  // dump() {
  //   reaction(() => [this.last, this.now],
  //     () => logger.log('DelayTimer', {
  //       last: this.last,
  //       now: this.now,
  //       reached: this.reached
  //     }));
  // }
}
